import React from 'react';
import { Text } from 'rizzui';
import CustomModal from '../../../components/modal/CustomModal';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      name={title}
      confirmText={confirmText}
      cancelText={cancelText}
      size="md"
    >
      <Text className="text-gray-600">
        {message}
      </Text>
    </CustomModal>
  );
};

export default ConfirmationModal;